export const obtainable = (l10n={}, it = {}) => {
    let acquire = ( it.obtainableByProduction || it.obtainableByMerchant || it.obtainableByCasting || it.obtainableByMonster );
    let use = ( it.productible || it.favorable || it.moldable || it.favorable );

    const htmlEl = document.getElementsByTagName("html")[0];
    let country = (htmlEl.dataset.country || 'KO').toLowerCase();

    return `
    <section class="obtainable">
        <header>
            <h3>${l10n['item.getUse']}</h3>
            <button class="btn-folder is-active"></button>
        </header>
        <article class="is-active">
            ${(!acquire && !use)? `<p>${l10n['common.unknown']}</p>`: `
            <ul>
                <li>
                    <div class="key">${l10n['item.howToObtain']}</div>
                    <div class="value">
                        ${acquire? `
                        ${it.obtainableByProduction? `<p><a href="/${country}/info/craft/?craftoutputid=${it.id}">${l10n['item.Craft']}</a></p>`:``}
                        ${it.obtainableByMerchant? `<p>${l10n['item.Merchant']}</p>`:``}
                        ${it.obtainableByCasting? `<p>${l10n['item.Forge']}</p>`:``}
                        ${it.obtainableByMonster? `<p>${l10n['item.Monster']}</p>`:``}
                        `: `<p>${l10n['common.unknown']}</p>` }
                    </div>
                </li>
                ${use? `
                <li>
                    <div class="key">${l10n['item.whereToUse']}</div>
                    <div class="value">
                        ${it.productible? `<p><a href="/${country}/info/craft/?craftinputid=${it.id}">${l10n['item.Craft']}</a></p>`:``}
                        ${it.favorable? `<p>${l10n['item.MerchantFriendship']}</p>`:``}
                        ${it.moldable? `<p>${l10n['item.Forge']}</p>`:``}
                    </div>
                </li>
                `: `` }
            </ul>` }
        </article>
    </section>`;
}
